import ProfileFilledIcon from './ProfileFilledIcon';
export default ProfileFilledIcon;
